import React from "react";

const CellInput = ({ column, index, updateRows, rows }) => {
  const maxStringSize = 64;
  const truncate = max => str => str.substring(0, max);

  return (
    <input
      style={{
        backgroundColor: "#fafafa",
        width: "100%",
        border: "1px solid black"
      }}
      onChange={e => {
        const newLabel = truncate(maxStringSize)(e.target.value);
        const updatedRows = [...rows];
        updatedRows[index][column.id] = newLabel;
        updateRows(updatedRows);
      }}
      value={rows[index][column.id]}
    />
  );
};

export default CellInput;
